import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Trophy, ArrowLeft, Crown } from 'lucide-react';
import { useAuth } from './AuthContext';
import { apiError } from './api';

export default function Login() {
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', name: '', role: 'club' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      if (mode === 'login') await login(form.email, form.password);
      else await register(form);
      nav('/tournaments');
    } catch (e2) {
      setErr(apiError(e2));
    }
    setBusy(false);
  };

  const set = (k, v) => setForm({ ...form, [k]: v });
  const inputCls = "w-full bg-[#1C1C1E] border border-gray-800 rounded-xl p-4 text-white text-sm focus:outline-none focus:border-[#00BFFF]";

  return (
    <div className="ttheme min-h-screen bg-[#0A0A0A] text-white flex flex-col items-center justify-center px-5 font-sans">
      <Link to="/" className="absolute top-5 left-5 text-gray-500 flex items-center gap-1 text-sm"><ArrowLeft size={16}/> Match Mode</Link>
      <Link to="/pricing" data-testid="login-pricing-link" className="absolute top-5 right-5 text-[#00BFFF] flex items-center gap-1 text-sm font-bold"><Crown size={15}/> Plans</Link>
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-8">
          <img src="/tournevo-logo.png" alt="Tournevo" className="w-40 h-40 object-contain rounded-2xl mb-2" />
          <p className="text-gray-500 text-sm mt-1">{mode === 'login' ? 'Sign in to manage your competitions' : 'Create your organiser account'}</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          {mode === 'register' && (
            <input data-testid="auth-name" className={inputCls} placeholder="Full name" value={form.name} onChange={(e) => set('name', e.target.value)} required />
          )}
          <input data-testid="auth-email" type="email" className={inputCls} placeholder="Email" value={form.email} onChange={(e) => set('email', e.target.value)} required />
          <input data-testid="auth-password" type="password" className={inputCls} placeholder="Password" value={form.password} onChange={(e) => set('password', e.target.value)} required />
          {mode === 'register' && (
            <div className="flex bg-[#1C1C1E] p-1 rounded-xl">
              {['club', 'referee'].map((r) => (
                <button type="button" key={r} data-testid={`auth-role-${r}`} onClick={() => set('role', r)}
                  className={`flex-1 py-2.5 rounded-lg text-xs font-bold uppercase tracking-wider ${form.role === r ? 'bg-[#00BFFF] text-black' : 'text-gray-400'}`}>{r}</button>
              ))}
            </div>
          )}
          {err && <p data-testid="auth-error" className="text-[#FF3B30] text-sm text-center">{err}</p>}
          <button data-testid="auth-submit" disabled={busy} className="w-full bg-[#00BFFF] text-black font-bold text-base py-4 rounded-xl disabled:opacity-50">
            {busy ? 'Please wait…' : mode === 'login' ? 'SIGN IN' : 'CREATE ACCOUNT'}
          </button>
        </form>

        <p className="text-center text-gray-500 text-sm mt-6">
          {mode === 'login' ? "No account? " : 'Already registered? '}
          <button data-testid="auth-toggle" onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setErr(''); }} className="text-[#00BFFF] font-bold">
            {mode === 'login' ? 'Sign up' : 'Sign in'}
          </button>
        </p>
      </div>
    </div>
  );
}
